import { documentsAPI, usersAPI, tasksAPI, fixFileApi } from '../api'
export const CHECKTRAIL_REPORT_SEND = 'CHECKTRAIL_REPORT_SEND'
export const GET_S2_LINK = 'GET_S2_LINK'
export const CHECK_FIX_OPR = 'CHECK_FIX_OPR'
export const FILE_UPLOAD_VERIFY = 'FILE_UPLOAD_VERIFY'
export const ADD_UPLOADED_FILES = 'ADD_UPLOADED_FILES'
export const UPDATE_UPLOAD_PROGRESS = 'UPDATE_UPLOAD_PROGRESS'
export const CLEAR_UPLOAD_PROGRESS = 'CLEAR_UPLOAD_PROGRESS'
export const UPDATED_FILE = 'UPDATED_FILE'
export const VIEW_SUMMARY_LINK = 'VIEW_SUMMARY_LINK'
export const MYDOCUMENTS_WIP = 'MYDOCUMENTS_WIP'
export const MYDOCUMENTS_ERROR = 'MYDOCUMENTS_ERROR'
export const VALIDATION_REPORT_SENT = 'VALIDATION_REPORT_SENT'
export const DOWNLOAD_VALIDATION_REPORT = 'DOWNLOAD_VALIDATION_REPORT'

import { encryptStorage } from 'src/Util'

export const checkTrailReportSend = (data) => (dispatch) => {
  usersAPI.post('/user/trail/sendReport', data).then((res) => {
    console.log('mail res', res)
    dispatch({
      type: VALIDATION_REPORT_SENT,
      payload: res.data,
    })
  })
}

export const fileUploadLink = () => (dispatch) => {
  const userDetail = encryptStorage.getItem('userDetails')
  documentsAPI
    .post(`/document/fileuploadlinkgen2`, { company_id: userDetail?.company_id })
    .then((response) => {
      dispatch({
        type: GET_S2_LINK,
        payload: response.data,
      })
    })
}

export const checkOrFix = (fileDetails, operation) => (dispatch) => {
  console.log('Invoked  ::', operation)
  console.log('fileDetails  ::', fileDetails)

  var s3Path = fileDetails.s3Path

  if (
    fileDetails.format.toLowerCase() == 'pdf' &&
    (fileDetails.fixCompleted || fileDetails.reviewCompleted)
  ) {
    s3Path = s3Path.replace('/source', '/output')
  }

  const userDetail = encryptStorage.getItem('userDetails')
  let loggedUserId = sessionStorage.getItem('trial-userId');
  let checkFFixOpr = {
    // user_id: userDetail.userId,
    // user_id: 1582,
    // companyId: userDetail.company_id,
    companyId: 337,
    user_id: loggedUserId,
    id: fileDetails.fileId,
    fileName: fileDetails.fileName,
    s3path: s3Path,
    service_name: operation,
  }
  fixFileApi.post(`/fix/Accessibilitycheckorfix`, checkFFixOpr).then((response) => {
    let data = response.data.data

    dispatch({
      type: CHECK_FIX_OPR,
      payload: { data, operation, fileId: fileDetails.fileId },
    })
  })
}

export const verifyFile = (document) => (dispatch) => {
  const userDetail = encryptStorage.getItem('userDetails')
  let loggedUserId = sessionStorage.getItem('trial-userId');
  ;(document.user_id = loggedUserId),
    (document.company_id = `${userDetail.company_id}`),
    documentsAPI.post('/document/check-file-version', document).then((fileUpdateMydocResponse) => {
      if (fileUpdateMydocResponse.data.data) {
        if (
          fileUpdateMydocResponse.data.data.uploadResponse ==
          'Duplicate file upload. You already have a version of this file.'
        ) {
          //$scope.sameVersionFiles.push({ 'fileName': fileUpdateMydocResponse.data.data.name })
          console.log(fileUpdateMydocResponse.data.data.uploadResponse)
          dispatch({
            type: FILE_UPLOAD_VERIFY,
            payload: {
              uuid: document.uuid,
              message: fileUpdateMydocResponse.data,
            },
          })
        } else if (response.data.data.uploadResponse == 'This file is already assigned to you.') {
          // assignee scenrio
          dispatch({
            type: FILE_UPLOAD_VERIFY,
            payload: {
              uuid: document.uuid,
              message: fileUpdateMydocResponse.data,
            },
          })
          //$scope.assignedFiles.push({ 'fileName': fileUpdateMydocResponse.data.data.name, 'user': fileUpdateMydocResponse.data.data.original_user})
        } else if (
          response.data.data.uploadResponse == 'You have assigned this file to someone already'
        ) {
          // original user scenrio
          //console.log(fileUpdateMydocResponse.data.data.uploadResponse);
          dispatch({
            type: FILE_UPLOAD_VERIFY,
            payload: {
              uuid: document.uuid,
              message: fileUpdateMydocResponse.data,
            },
          })
          //$scope.originalUserFiles.push({ 'fileName': fileUpdateMydocResponse.data.data.name , 'user': fileUpdateMydocResponse.data.data.assigned_user, 'permission': fileUpdateMydocResponse.data.data.permission})
        } else {
        }
      }
      console.log('Insert file here', document.fileId)
      if (document.fileId === undefined) dispatch(insertFile(document))
      else dispatch(updateFile(document))
      // dispatch({
      //   type: FILE_UPLOAD_VERIFY,
      //   payload: fileUpdateMydocResponse.data,
      // })
    })
}

export const insertFile = (document) => (dispatch) => {
  console.log('insert file')
  const userDetail = encryptStorage.getItem('userDetails')
  let loggedUserId = sessionStorage.getItem('trial-userId');
  let data = {
    fileName: document.file_name,
    // company_id: `${userDetail.company_id}`,
    // companyId: `${userDetail.company_id}`,
    company_id: 337,
    companyId: 337,

    startDate: new Date(),
    statusId: 2,
    size: document.size,
    format: document.file_name
      .slice(Math.max(0, document.file_name.lastIndexOf('.')) + 1)
      .toUpperCase(),
    stage: 'upload',
    createdBy: loggedUserId,
    randomId: document.uuid,
    storageType: 's3',
    s3Path: document.s3_path,
    user_id: loggedUserId,
    duplicateCheckRequired : false
  }

  documentsAPI
    .post('/document/files', data)
    .then((fileUpdateMydocResponse) => {
      console.log('File Entry Response', fileUpdateMydocResponse)
      dispatch({
        type: FILE_UPLOAD_VERIFY,
        payload: { uuid: document.uuid, data: fileUpdateMydocResponse.data.data, valid: true },
      })
    })
    .catch(function (error) {
      console.log('Error :', error)
      dispatch({
        type: FILE_UPLOAD_VERIFY,
        payload: { uuid: document.uuid, data: error.response.data.data, valid: false },
      })
    })
}

export const updateFile = (document) => (dispatch) => {
  console.log('insert file')
  const userDetail = encryptStorage.getItem('userDetails')
  let loggedUserId = sessionStorage.getItem('trial-userId');
  let data = {
    fileName: document.file_name,
    company_id: 337,
    companyId: 337,
    // company_id: `${userDetail.company_id}`,
    // companyId: `${userDetail.company_id}`,
    startDate: new Date(),
    statusId: 2,
    size: document.size,
    format: document.file_name
      .slice(Math.max(0, document.file_name.lastIndexOf('.')) + 1)
      .toUpperCase(),
    stage: 'upload',
    createdBy: loggedUserId,
    randomId: document.uuid,
    storageType: 's3',
    s3Path: document.s3_path,
    user_id: loggedUserId,
    fileId: document.fileId,
    duplicateCheckRequired : false
  }

  documentsAPI
    .put('/document/files', data)
    .then((fileUpdateMydocResponse) => {
      console.log('File Entry Response', fileUpdateMydocResponse)
      dispatch({
        type: FILE_UPLOAD_VERIFY,
        payload: { uuid: document.uuid, data: fileUpdateMydocResponse.data.data, valid: true },
      })
    })
    .catch(function (error) {
      console.log('Error :', error)
      dispatch({
        type: FILE_UPLOAD_VERIFY,
        payload: { uuid: document.uuid, data: error.response.data.data, valid: false },
      })
    })
}

export const getFileById = (files) => (dispatch) => {
  console.log('fileUpdateMydoc==getSingle===>', files.fileId)

  documentsAPI.get('/document/files/' + files.fileId).then((fileUpdateMydocResponse) => {
    let loggedUserId = sessionStorage.getItem('trial-userId');
    const userDetail = encryptStorage.getItem('userDetails')
    let searchObj = {
      limit: 10,
      offset: 0,
      sortBy: 'startDate',
      sortOrder: 'desc',
      stage: 'WIP',
      userId : loggedUserId
    }
    documentsAPI.post('/document/files-search', searchObj).then((myDocswipResponse) => {
      console.log('mydocwipRespose', myDocswipResponse)
      dispatch({
        type: MYDOCUMENTS_WIP,
        payload: myDocswipResponse.data,
      })
    })

    dispatch({
      type: UPDATED_FILE,
      payload: fileUpdateMydocResponse.data,
    })
  })
}

export const addUploadedFiles = (data) => (dispatch) => {
  console.log('addUploadedFiles invoked')
  dispatch({
    type: ADD_UPLOADED_FILES,
    payload: data,
  })
}
export const updateUploadProgress = (data) => (dispatch) => {
  dispatch({
    type: UPDATE_UPLOAD_PROGRESS,
    payload: data,
  })
}

export const clearUploadProgress = () => (dispatch) => {
  dispatch({
    type: CLEAR_UPLOAD_PROGRESS,
  })
}

export const fileHistoryDownload = (downloadDetails) => (dispatch) => {
  console.log('fileHistoryDownload ::', downloadDetails)
  const userDetail = encryptStorage.getItem('userDetails')
  // downloadDetails.company_id = userDetail.company_id
  downloadDetails.company_id = 337

  downloadDetails.user_id = sessionStorage.getItem('trial-userId')
  tasksAPI.post(`/task/file/viewForUser`, downloadDetails).then((response) => {
    console.log('fileHistoryDownload ::: ', response.data)
    dispatch({
      type: DOWNLOAD_VALIDATION_REPORT,
      payload: response.data,
    })
    window.open(response.data.data, '_blank')
    // dispatch({
    //   type: GET_DOWNLOAD_LINK,
    //   payload: response.data,
    // })
  })
}

export const fileHistorySummary = (path, version) => (dispatch) => {
  console.log('fileHistoryDownload ::', path)
  const userDetail = encryptStorage.getItem('userDetails')
  let downloadDetails = {
    company_id: sessionStorage.getItem('trial-companyId'),
    user_id: sessionStorage.getItem('trial-userId'),
    type: 's3',
    destinationPath: path,
    s3_version_id: version,
  }
  tasksAPI.post(`/task/file/viewForUser`, downloadDetails).then((response) => {
    console.log('fileHistoryDownload ::: ', response.data)
    dispatch({
      type: VIEW_SUMMARY_LINK,
      payload: response.data,
    })
  })
}

export const myDocsWip = (searchObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('userDetails')
  console.log('searchObj', searchObj)
  searchObj.userId = sessionStorage.getItem('trial-userId')
  documentsAPI.post('/document/files-search', searchObj).then((myDocswipResponse) => {
    console.log('mydocwipRespose', myDocswipResponse)
    dispatch({
      type: MYDOCUMENTS_WIP,
      payload: myDocswipResponse.data,
    })
  })
}

export const myDocsError = (searchObj) => (dispatch) => {
  const userDetail = encryptStorage.getItem('userDetails')
  searchObj.userId = sessionStorage.getItem('trial-userId')
  documentsAPI.post('/document/files-search', searchObj).then((myDocserrorResponse) => {
    dispatch({
      type: MYDOCUMENTS_ERROR,
      payload: myDocserrorResponse.data,
    })
  })
}
